<template>
		<div class="course-list">
			<!-- <div v-if="showIframe">
				<div class="back" @click="goBack">返回</div>
			  <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="iframeSrc" style="width: 100%; height: calc(100vh - 4rem); border: none;"></iframe>
			</div> -->
			<div v-if="!showIframe" class="sub-head">
				<div class="course-title">课程列表</div>
				<div class="subject">
					<div class="tab" v-for="(item,index) in tabList" :key="index" :class="actTab==item.id?'actTab':''" @click="getSubject(item.id)">{{item.name}}</div>
				</div>
			</div>	
			<div v-if="!showIframe" class="course-cont">
				<div class="course-card" @click="goDetail(item)" v-for="(item,index) in courseList" :key="index">
					<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
						<!-- <div v-if="item.isComplete" class="course-study course-study-end">已完成</div> -->
						<!-- <div v-else-if="item.isContinue" class="course-study">继续学习</div> -->
						<img v-if="item.ruo" class="course-ruo" src="../assets/ruo-icon.png" alt="" />
					</div>
					<div class="course-name">{{item.point_name}}</div>
					<div class="course-text">{{item.point_info}}</div>
					<div class="course-btn">
						<!-- <img class="course-avator" :src="item.avator" alt="" /> -->
						<span class="course-teacher">{{item.teacher}}</span>
						<div v-if="item.isCollect" class="course-save course-save-act" @click.stop="collect(item)"></div>
						<div v-else class="course-save" @click.stop="collect(item)"></div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			num:9999,//课数量
			actTab:localStorage.getItem('actTab')||1,
			showIframe: false,
			iframeSrc: '',
			courseList:[],
			collectList:[],
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			tabList:[
				{
					id:1,
					name:'数学'
				},
				{
					id:2,
					name:'英语'
				},
				{
					id:3,
					name:'物理'
				},
			]
		}
	},

	created(){
		if(localStorage.getItem('routeType') == 'home'){
			localStorage.removeItem('routeType')
			this.goDetail(JSON.parse(this.$route.query.item));
			return;
		}
		// this.setTab();
		if(!this.actTab){
			localStorage.removeItem('actTab');
			this.$message('当前没有学习权限，请联系老师');
			return;
		}
		this.init();
	},
	mounted() {
	    this.$eventBus.$on('initPage', this.goBack);
	},
	beforeDestroy() {
	    this.$eventBus.$off('initPage', this.goBack);
	},

	computed: {

	},
	watch: {

	},
	methods: {
		async init(){
			await this.getWeaknessList();
			await this.getCollectList();//获取收藏清单
			await this.getLearnList(true);
			await this.getLearnList(false);
			if(localStorage.getItem('courseHot')||localStorage.getItem('testHot')){//用户产生行为了
				this.getWeakness();//调取清单各项数据
			}else{
				this.getMenuList();//不产生行为直接调取id集合
			}
		},
		// setTab(){
		// 	if(this.userInfo.authIds.indexOf(2)!=-1&&localStorage.getItem("schoolType") == "C"){//初中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(1)!=-1&&localStorage.getItem("schoolType") == "C"){//初中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// 	if(this.userInfo.authIds.indexOf(4)!=-1&&localStorage.getItem("schoolType") == "G"){//高中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(3)!=-1&&localStorage.getItem("schoolType") == "G"){//高中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// },
		setTab(){
			if(!this.userInfo.authIds){
				return '授权时间已过，请联系相关老师开通新的授权。'
			}
			if(this.actTab == 1){
				if(this.userInfo.authIds.indexOf(3)==-1&&localStorage.getItem("schoolType") == "C"){//初中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(4)==-1&&localStorage.getItem("schoolType") == "G"){//高中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 2){
				if(this.userInfo.authIds.indexOf(1)==-1&&localStorage.getItem("schoolType") == "C"){//初中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(2)==-1&&localStorage.getItem("schoolType") == "G"){//高中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 3){
				if(this.userInfo.authIds.indexOf(5)==-1&&localStorage.getItem("schoolType") == "C"){//初中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(6)==-1&&localStorage.getItem("schoolType") == "G"){//高中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}
			return false
		},
		async getMenuList() {
			let jsondata = {
				type: 1,
				subject:this.actTab
			}
			const res = await this.$api.getMenuList(jsondata);
			if (res.data.success) {
				if(res.data.data.length==0){//集合没数据调取清单数据
					this.getWeakness();
				}else{//有数据用id集合拉取指定知识点
					this.getCourseList({
						idList:res.data.data,//知识点id
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getMenuAdd() {
			let pointIds = this.courseList.map(course => course.point_id);
			let jsondata = {
				type: 1,
				pointIds:pointIds,
				subject:this.actTab
			}
			const res = await this.$api.getMenuAdd(jsondata);
			if (res.data.success) {
				//更新知识点id集合
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeakness(){
			//用清单换知识点
			this.getCourseList({
				ruoList:this.ruoIdList,//个人弱点清单（知识点）
				ruoPublicList:await this.getWeaknessTopList(),//大众弱点清单（知识点）
				collectList:this.collectList,//我的收藏清单（知识点）
				completeList:this.completeList,//完课清单（知识点）
				questionList:this.questionList,//学习记录
				num:this.num,//课数量
			});
		},
		async getCourseList(actjson) {
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				phone:this.userInfo.accountCode,//手机号
				subject:this.actTab,//学科
				city:this.userInfo.cityId,//城市
				school:this.userInfo.schoolId,//学校
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId
			};
			const res = await this.$api.getCourseList({...jsondata,...actjson});
			if (res.data.code === 0) {
				this.courseList = res.data.data
				// if(this.actTab==1&&(grades||this.userInfo.gradeClass.split("/")[0])=='高中'){
				// 	this.courseList.unshift({
				// 		point_id:847,
				// 		point_name:'三角函数',
				// 		point_info:'三角函数平移问题',
				// 		qf_url:'ttps://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=372',
				// 		coverImg:'https://view.duofenpai.com/image/default/3450E085CBE84B58B2A85123AEF0C1ED-6-2.png',
				// 	})
				// }
				// localStorage.removeItem('courseHot')
				this.getMenuAdd();
				//设置收藏
				if (this.collectList && this.collectList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.collectList.includes(course.point_id.toString())) {
				            course.isCollect = true;  // 设置收藏
				        }
				    });
				}
				//设置弱点
				if (this.ruoIdList && this.ruoIdList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.ruoIdList.includes(course.point_id.toString())) {
				            course.ruo = true;  // 设置弱点
				        }
				    });
				}
				
				//设置完成记录
				if (this.completeList && this.completeList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.completeList.includes(course.point_id.toString())) {
				            course.isComplete = true;  // 设置已完成
				        }
				    });
				}
				
				//设置学习记录
				if (this.questionList && this.questionList.length > 0) {
				    this.questionList.forEach(questionItem => {
				      this.courseList.forEach(courseItem => {
				        if (questionItem.point_id == courseItem.point_id) {
				          courseItem.isContinue = true;
				        }
				      });
				    });
				}
				
				this.$forceUpdate();
				console.log('courseList',this.courseList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessList() {
			const res = await this.$api.getWeaknessList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,
			});
			if (res.data.success) {
				this.ruoIdList = res.data.data.map(item => item.pointId);
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessTopList() {
			const res = await this.$api.getWeaknessTopList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,
			});
			if (res.data.success) {
				return res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getLearnList(isComplete){
			const res = await this.$api.getLearnQfList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,
				isComplete:isComplete
			});
			if (res.data.success) {
				let resData = [];  // 确保 resData 是一个空数组
				if(isComplete){
					res.data.data.forEach(item => {
					  resData.push(item.pointId);  // 将每个子项的 pointId 推入 this.resData 数组
					});
					this.completeList = resData;
				}else{					
					res.data.data.forEach(item => {
					  // 创建 resData 的单个对象，并设置 point_id
					  const resItem = {
					    point_id: item.pointId,
					    children: []  // 初始化 children 数组
					  };
						item.children = item.children || []
					  // 遍历当前 item 的 children 数组
					  item.children.forEach(child => {
					    resItem.children.push({
					      id: child.businessId,  // 设置 id 为 businessId
					      status: 1  // 设置 status 为 1
					    });
					  });
					
					  // 将构造好的 resItem 推入到 resData 中
					  resData.push(resItem);
						this.questionList = resData;
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async collect(item) {
			let jsondata = {
				pointId:item.point_id,
				type: 1,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				subject:this.actTab
			};
			if(item.isCollect){
				const res = await this.$api.getCollectRemove(jsondata);
				if (res.data.success) {
					this.$message.success('取消收藏成功')
					localStorage.setItem('courseHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}else{
				const res = await this.$api.getCollectAdd(jsondata);
				if (res.data.success) {
					this.$message.success('收藏成功')
					localStorage.setItem('courseHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}
		},
		async getCollectList() {
			const res = await this.$api.getCollectList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type: 1,
			});
			if (res.data.success) {
				this.collectList = res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		goDetail(item){
			let msg = this.setTab();
			if(msg&&item.point_id!='847'){
				this.$message.warning(msg);
				return;
			}
			console.log('aaa',item)
			// if(qfurl){
			// 	this.showIframe = true;
			// 	this.iframeSrc = qfurl;
			// }else{
				this.$router.push({  //核心语句
				  path:'/courseDetail',   //跳转的路径
				  query:{
					  id:item.point_id,
						name:item.point_name,
					  subject:this.actTab,
					  fromRuo: item.fromRuo || false
				  }
				})
			// }
		},
		getSubject(i){
			this.actTab = i;
			localStorage.setItem('actTab',i);
			this.init();
		},
		goBack(){
			this.showIframe = false;
			this.iframeSrc = '';
		}
	}
}
</script>

<style lang="scss" scoped>
.course-list{
	padding: 1.5rem 0 5rem 0.75rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 5.8rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.course-cont{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		.course-card{
			width: 18.35rem;
			height: 14.45rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			overflow: hidden;
			margin: 0.7rem;
			.course-bg{
				width: 18.35rem;
				height: 7.5rem;
				background-repeat: no-repeat;
				background-size: cover;
				position: relative;
				.course-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.course-study-end{
					background: #00d215;
					color: #fff;
				}
				.course-ruo{
						position: absolute;
						right: 0;
						top: 0;
						width: 2.45rem;
						height: 2.05rem;
				}
			}
			.course-name{
				margin: 0.75rem 0.9rem 0.6rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.1rem;
				color: #1D1D1D;
				line-height: 1.1rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
			}
			.course-text{
				margin: 0 0.9rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #74798C;
				line-height: 1rem;
				height:2rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;

			}
			.course-btn{
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin: 0 0.9rem;
				.course-avator{
					width: 1.2rem;
					height: 1.2rem;
					border-radius: 6rem;
					margin-right: 0.4rem;
				}
				.course-teacher{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #1D1D1D;
					line-height: 1.12rem;
				}
				.course-save{
					background-image: url('../assets/heart-1.png');
					background-repeat: no-repeat;
					background-size: contain;
					width: 1.2rem;
					height: 1.2rem;
					margin-left: auto;
				}
				.course-save-act{
					background-image: url('../assets/heart.png');
				}
			}
		}
	}
}
.back{
	text-align: center;
	width: 4rem;
	height: 4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 1.88rem;
	position: absolute;
	bottom: 5rem;
	left: 2rem;
	z-index: 999;
	color: #FFFFFF;
	background: rgb(100, 45, 113);
	border: 0.2rem solid #E0E0E0;
}
</style>
